export default {
    products: [],
    transfers: [],
    places: [],
    filter: {
        query: '',
    },
    orderBy: 'alfabetico',
    isloadingProducts: false,
    productDetail: null,        
    selectedCategory: null,
    SelectedExperienceDate:null          
}